import { IonIcon } from '@ionic/react';
import { ComponentProps, ReactNode } from 'react';
import { useIntl } from 'react-intl';

import styles from '@components/text/TextWithIcon.module.css';
import { maybeWrapElementInHoverText } from '@utils/htmlUtils';
import { IconList, IconName } from '@utils/iconUtils';

type Props = ComponentProps<typeof IonIcon> & {
  ariaLabelKey: string;
  className?: string;
  hoverContent?: ReactNode;
  icon: IconName;
};

const Icon = ({ ariaLabelKey, className, hoverContent, icon }: Props) => {
  const intl = useIntl();

  return maybeWrapElementInHoverText(
    hoverContent,
    <IonIcon
      aria-label={intl.formatMessage({ id: ariaLabelKey })}
      className={className ? className : icon === 'spinner' ? styles.spinningIcon : ''}
      data-test="icon"
      src={IconList[icon]}
    />
  );
};

export default Icon;
